import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DeleteInvoiceView from '../DeleteInvoiceView';
import { ConfigContext } from '../../context/GlobalContext';
import * as actionType from "../../context/actions";
import { FilterdData } from '../../helper/FilterdData';
import DataNotFoundView from '../DataNotFoundView';
import { useNavigate } from 'react-router-dom';
import { Languages } from '../../Utils/Languages';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Currancy from '../../Utils/currency.json';


const RecentInvoices = ({ InvoicesData }) => {

    const navigate = useNavigate();

    const { state, dispatch } = useContext(ConfigContext);

    const [invoiceDataData, setInvoiceData] = useState(state?.INVOICES);

    useEffect(() => {
        setInvoiceData(FilterdData(state, state?.INVOICES, "date")?.slice(0, 5))
    }, [state])


    useEffect(() => {
        // Select all elements with data-bs-toggle="DefaultTooltipThree"
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
        // Initialize tooltips
        const tooltipList = Array.from(tooltipTriggerList).map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
        // Cleanup on unmount
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, []);

    return (
        <div className="col-12">
            <div className="card h-100">
                <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                    <h6 className="mb-2 fw-bold text-lg mb-0">{Languages[state?.LANGUAGE]?.recent_invoice}</h6>
                    {invoiceDataData?.length > 0 && (<Link
                        to="/invoice-list"
                        className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                    >
                        {Languages[state?.LANGUAGE].view_all}
                        <Icon
                            icon="solar:alt-arrow-right-linear"
                            className="icon"
                        />
                    </Link>)}
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <div className="table-responsive scroll-sm">
                            {invoiceDataData?.length > 0 ? (
                                <table
                                    className="table bordered-table mb-0"
                                    id="dataTable"
                                    data-page-length={10}
                                >
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <div className="form-check style-check d-flex align-items-center">
                                                    {/* <input className="form-check-input" type="checkbox" /> */}
                                                    <label className="form-check-label">{Languages[state?.LANGUAGE].s_r}</label>
                                                </div>
                                            </th>
                                            <th scope="col">{Languages[state?.LANGUAGE].invoice_no}</th>
                                            <th scope="col">{Languages[state?.LANGUAGE].customer_name}</th>
                                            <th scope="col" className='dt-orderable-asc dt-orderable-desc'>{Languages[state?.LANGUAGE].amount}</th>
                                            <th scope="col">{Languages[state?.LANGUAGE].issued_date}</th>
                                            <th scope="col">{Languages[state?.LANGUAGE].status}</th>
                                            <th scope="col">{Languages[state?.LANGUAGE].action}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoiceDataData?.map((invoice, index) => (
                                            <tr key={index}>
                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey == "true" || invoice?.paidFlagKey == true) {
                                                            navigate("/invoice-preview")
                                                        }
                                                        else {
                                                            navigate("/invoice-edit")
                                                        }
                                                    }}
                                                >
                                                    <div className="form-check style-check d-flex align-items-center">
                                                        <label className="form-check-label">{index + 1}</label>
                                                    </div>
                                                </td>

                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey == "true" || invoice?.paidFlagKey == true) {
                                                            navigate("/invoice-preview")
                                                        }
                                                        else {
                                                            navigate("/invoice-edit")
                                                        }
                                                    }}
                                                >
                                                    <div className="form-check style-check d-flex align-items-center">
                                                        <label className="form-check-label">{invoice?.id}</label>
                                                    </div>
                                                </td>

                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey === "true" || invoice?.paidFlagKey === true) {
                                                            navigate("/invoice-preview");
                                                        } else {
                                                            navigate("/invoice-edit");
                                                        }
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                            {
                                                                state?.CUSTOMERS?.find(
                                                                    (cust) => cust.customerId?.toString() === invoice.customerId?.toString()
                                                                )?.customer || "Unknown"
                                                            }
                                                        </h6>
                                                    </div>
                                                </td>
                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey == "true" || invoice?.paidFlagKey == true) {
                                                            navigate("/invoice-preview")
                                                        }
                                                        else {
                                                            navigate("/invoice-edit")
                                                        }
                                                    }}
                                                >
                                                    {(() => {
                                                        const matchedCurrency = invoice?.currency ? Currancy.CountryCurrencyResponse.find(
                                                            (c) => c.currencyCode === invoice.currency
                                                        ) : null;
                                                        const currencyCode = matchedCurrency ? matchedCurrency.currencyCode : state?.CURRENCYCODE;
                                                        const currencySymbol = matchedCurrency ? matchedCurrency.currencytSymbol : state?.SYMBOL;
                                                        return currencySymbol === "$" ? `${currencyCode} ${currencySymbol} ${invoice?.totalAmount}` : `${currencySymbol} ${invoice?.totalAmount}`;
                                                    })()}
                                                </td>

                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey == "true" || invoice?.paidFlagKey == true) {
                                                            navigate("/invoice-preview")
                                                        }
                                                        else {
                                                            navigate("/invoice-edit")
                                                        }
                                                    }}
                                                >
                                                    {new Date(parseInt(invoice?.date?.length > 10 ? invoice?.date : invoice?.date * 1000)).toDateString()}
                                                </td>

                                                <td
                                                    className='cursor-pointer'
                                                    onClick={() => {
                                                        if (!state?.USERID) {
                                                            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                            return;
                                                        }
                                                        dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        if (invoice?.paidFlagKey == "true" || invoice?.paidFlagKey == true) {
                                                            navigate("/invoice-preview")
                                                        }
                                                        else {
                                                            navigate("/invoice-edit")
                                                        }
                                                    }}
                                                >
                                                    {" "}
                                                    <span
                                                        className={`px-24 py-4 rounded-pill fw-medium text-sm ${invoice.paidFlagKey == "true" || invoice.paidFlagKey == true
                                                            ? "bg-success-focus text-success-main"  // If paid
                                                            : "bg-danger-focus text-danger-main"    // If unpaid
                                                            }`}
                                                    >
                                                        {(invoice.paidFlagKey == "true" || invoice.paidFlagKey == true) ? Languages[state?.LANGUAGE].paid : Languages[state?.LANGUAGE].unpaid}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link
                                                        onClick={(e) => {
                                                            if (!state?.USERID) {
                                                                e.preventDefault();
                                                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                                return;
                                                            }
                                                            dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        }}
                                                        to="/invoice-preview"
                                                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        data-bs-toggle="DefaultTooltipThree"
                                                        data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-primary"
                                                        data-bs-title="View Invoice"
                                                    >
                                                        <Icon icon="iconamoon:eye-light" />
                                                    </Link>
                                                    <Link
                                                        onClick={(e) => {
                                                            if (!state?.USERID) {
                                                                e.preventDefault();
                                                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                                return;
                                                            }
                                                            dispatch({ type: actionType.SELECTEDINVOICE, payload: invoice.invoiceId });
                                                        }}
                                                        to="/invoice-edit"
                                                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        data-bs-toggle="DefaultTooltipThree"
                                                        data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-success"
                                                        data-bs-title="Edit Invoice"
                                                    >
                                                        <Icon icon="lucide:edit" />
                                                    </Link>
                                                    <Link
                                                        data-bs-toggle="DefaultTooltipThree"
                                                        data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-danger"
                                                        data-bs-title="Delete Invoice"
                                                    >
                                                        <DeleteInvoiceView FirebaseId={invoice.uniqueID} />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            )
                                : (
                                    <DataNotFoundView height={350} />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecentInvoices;